import $ from 'jquery';
import './../../../psyhulp/js/src/utilities';
import './../../../psyhulp/js/src/processors';
import 'bootstrap';
import './navigation';
import './../../../psyhulp/js/src/password';
import popovers from './../../../psyhulp/js/src/popover';
import modal from './../../../psyhulp/js/src/modal';
import './../../../psyhulp/js/src/add-more';
import './../../../psyhulp/js/src/ajax';
import isdirty from './../../../psyhulp/js/src/is-dirty';
import datepicker from './../../../psyhulp/js/src/datepicker';
import {
    processor
} from './../../../psyhulp/js/src/processors';
import autocomplete from './../../../psyhulp/js/src/autocomplete';
import sortable from './../../../psyhulp/js/src/sortable';
import databinding from './../../../psyhulp/js/src/data-binding';
import './../../../psyhulp/js/src/print';
import './../../../psyhulp/js/src/not-clickable';
import './../../../psyhulp/js/src/auto-create-new';
import './../../../psyhulp/js/src/tabs';
import faccordion from './../../../psyhulp/js/src/f-accordion';
import sliders from './../../../psyhulp/js/src/sliders';
import './../../../psyhulp/js/src/collapse';
import './../../../psyhulp/js/src/dropzone';
import './../../../psyhulp/js/src/timed-exercise';
import 'jquery-serializejson';
import weekschema from './../../../psyhulp/js/src/weekschema';
import './smoothscroll';
import './../../../psyhulp/js/src/scroll-to';
import './../../../psyhulp/js/src/back-to-top';
import tagify from './../../../psyhulp/js/src/tagify';
import carousel from './../../../psyhulp/js/src/carousel';
import 'bootstrap-contextmenu/contextmenu';
import WOW from 'wowjs';
import readMore from './read-more';
import './preloader';
import './breakpoints';
//import './dev-overlay';

$(function () {
    'use strict';

    window.processor = processor;

    /**
     * Off-canvas navigation
     */
    (function () {
        $('[data-toggle="offcanvas"]').on('click', function () {
            $(this).toggleClass('navbar-toggler-close');
            const navbar = $(this).closest('.navbar');
            navbar.find('.offcanvas-collapse').toggleClass('open');
            if (navbar.hasClass('position-fixed')) {
                navbar.removeClass('position-fixed');
                $('body').css('overflow', '');
            } else {
                navbar.addClass('position-fixed');
                $('body').css('overflow', 'hidden');
            }
        })
    })();


    /**
     * Focus on input-group click
     */
    (function () {
        $(document).on('click', 'a.input-group-text', function (e) {
            e.preventDefault();
            $(this).closest('.input-group').find('input.form-control').trigger('focus');
        });
    })();

    /**
     * Equal heights
     *
     */
    if ($.fn.matchHeight) {
        $('.equal-columns').matchHeight({
            byRow: $('.equal-columns').attr('data-disable-by-row') ? false : true
        });
    }

    /**
     * Tooltips
     */
    processor.registerProcessor(function (context) {
        $('[data-toggle=tooltip]:not([data-tooltip-options])', context).tooltip();
        $('[data-toggle=tooltip][data-tooltip-options]', context).each(function () {
            $(this).tooltip(JSON.parse($(this).attr('data-tooltip-options')));
        });
    });

    /**
     * Read more testimonials
     */
    processor.registerProcessor(readMore.initialize);

    /**
     * WoW
     */
    processor.registerProcessor(function() {
        const wow = new WOW.WOW();
        wow.init();
    });

    /**
     * Datepicker
     */
    processor.registerProcessor(datepicker.datepicker);

    /**
     * Popovers
     */
    processor.registerProcessor(popovers.popovers);

    /**
     * Modal windows
     */
    processor.registerProcessor(modal.autoShowModals);

    /**
     * Data binding
     */
    processor.registerProcessor(databinding.run);

    /**
     * Tag input
     */
    processor.registerProcessor(tagify.initialize);

    /**
     * Autocomplete
     */
    processor.registerProcessor(autocomplete.initialize);

    /**
     * Connected lists and sortables
     */
    processor.registerProcessor(sortable.initialize);

    /**
     * f-accordion
     */
    processor.registerProcessor(faccordion.initialize);

    /**
     * Sliders
     */
    processor.registerProcessor(sliders.initialize);

    /**
     * isDirty
     */
    processor.registerProcessor(isdirty.initialize);

    /**
     * Carousel using Tiny Slider 2
     */
    processor.registerProcessor(carousel.initialize);
    
    /**
     * Week schema
     */
    processor.registerProcessor(weekschema.weekschema);

    /**
     * Prevent icons on links from wrapping to the next line on its own without the last word attached to it.
     */
    processor.registerProcessor(function (context) {
        $('a.arrows, a.out, a.arrow-up', context || document).each(function () {
            var $this = $(this);
            if ($this.hasClass('stretched-link') || $this.find('> .stretched-link').length) {
                return;
            }
            let text = $this.text().trim();
            let lastSpaceIndex = text.lastIndexOf(' ');
    
            if (lastSpaceIndex !== -1) {
                let firstPart = text.substring(0, lastSpaceIndex);
                let lastWord = text.substring(lastSpaceIndex + 1);
    
                $this.html(`${firstPart} <span class="do-not-break">${lastWord}</span>`);
            }
        });

    });

    $(document).on('click', 'a[href=""]', function (e) {
        e.preventDefault();
    });

    processor.run(document);

    $('body').addClass('perform-transitions');
});